module.exports = __webpack_public_path__ + "static/logo_aquafan-e9173a7bc17e10aae418af8220b74ecc.png";